export function getWindowLocationLoadCompleteEvent(event) {
    var _a;
    if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) !== 'PINWHEEL_INTERNAL_COMM_DOWN')
        return false;
    if (event.data.eventName !== 'window_location_load_complete')
        return false;
    return event.data;
}
export function getWindowLocationLoadStartEvent(event) {
    var _a;
    if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) !== 'PINWHEEL_INTERNAL_COMM_DOWN')
        return false;
    if (event.data.eventName !== 'window_location_load_start')
        return false;
    return event.data;
}
export function getXmResponseEvent(event) {
    var _a;
    if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) !== 'PINWHEEL_INTERNAL_COMM_DOWN')
        return false;
    if (event.data.eventName === 'js_response')
        return event.data;
    if (event.data.eventName === 'xm_response')
        return event.data;
    return false;
}
export function getAnalyticsResponseEvent(event) {
    var _a;
    if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) !== 'PINWHEEL_INTERNAL_COMM_DOWN')
        return false;
    if (event.data.eventName === 'analytics_response')
        return event.data;
    return false;
}
export function getXmRequestPayload(event) {
    if (event.data.type !== 'PINWHEEL_INTERNAL_COMM_UP')
        return false;
    if (event.data.eventName !== 'xm_request')
        return false;
    return event.data.payload;
}
